import React, { createContext, useCallback, useContext, useEffect, useState } from 'react';
import { api } from '../lib/api';

const Ctx = createContext(null);

/**
 * Property config (name, logo_url, address, reception_phone) fetched once at
 * app boot and after any manager update. Deployable as a template — nothing
 * about "Bon Bini" is hardcoded outside of the DB default.
 */
export function PropertyProvider({ children }) {
  const [property, setProperty] = useState(null);

  const load = useCallback(async () => {
    try {
      const { data } = await api.get('/property');
      setProperty(data);
    } catch {
      // Never break the app on this; fall back to something safe.
      setProperty({ name: 'Front Desk Console', logo_url: '', address: '', reception_phone: '' });
    }
  }, []);

  useEffect(() => { load(); }, [load]);

  return <Ctx.Provider value={{ property, refresh: load, setProperty }}>{children}</Ctx.Provider>;
}

export const useProperty = () => useContext(Ctx);

/** Return an absolute URL for a possibly-relative uploaded logo path. */
export function resolveAsset(url) {
  if (!url) return '';
  if (url.startsWith('http')) return url;
  return `${process.env.REACT_APP_BACKEND_URL}${url}`;
}
